import { Box } from "@chakra-ui/react"
import React from "react"

export const SearchResultsWrapper = ({ children }) => {
  return <Box className="search-results">{children}</Box>
}
